<template>
  <div class="little-grey">
    <app-layout-header></app-layout-header>
    <div class="mh-60">
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>
    <div bottom="50px" right="50px" visibleoffset="500" class="btn-position">
      <button @click="onClickScrollTop" type="button" class="btn btn-pur-mid btn-to-top">
        <font-awesome-icon icon="chevron-up" />
      </button>
    </div>
    <app-layout-footer></app-layout-footer>
  </div>
</template>
<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faChevronUp } from '@fortawesome/free-solid-svg-icons'
import AppLayoutHeader from './AppLayoutHeader.vue'
import AppLayoutFooter from './AppLayoutFooter.vue'

library.add(faChevronUp)

export default {
  components: {
    AppLayoutHeader,
    AppLayoutFooter
  },
  methods: {
    onClickScrollTop () {
      this.$scrollTop()
    }
  }
}

</script>
<style scoped>
  .btn-to-top {
    width: 50px;
    height: 50px;
    padding: 10px;
    margin: -20px 20px 20px 20px;
    border-radius: 50%;
    font-size: 22px;
    line-height: 22px;
  }
  .btn-position {
    position: absolute;
    right: 0;
  }
  .little-grey {
    background-color: #fefefe;
  }
  .mh-60 {
    min-height: 60rem;
  }
</style>
<style>
  .little-grey {
    font-family: 'Avenir', Helvetica, Arial, sans-serif, 'Open Sans', Arial, Helvetica, '微軟正黑體', 'Microsoft JhengHei', '新細明體', Verdana, sans-serif; 
  }
  .mark-bottom {
	font-weight: bold;
	color: #5364b5;
  }
  a {
    color: #7b8cde;
  }
  a:hover {
    color: #5364b5;
  }
  .btn-pur-light, .btn-pur-light.disabled, .btn-pur-light:disabled {
    background-color: #7ba3de;
	border-color: #7ba3de;
	color: #fff
  }
  .btn-pur-light:focus {
    box-shadow: 0 0 0 0.2rem rgba(144, 183, 240, 0.5);
  }
  .btn-pur-light:hover, .btn-pur-light:focus, .btn-pur-light:not(:disabled):not(.disabled).active, .btn-pur-light:not(:disabled):not(.disabled):active{
    background-color: #6993d1;
	border-color: #6993d1;
	color: #fff;
  }
  .btn-pur-mid, .btn-pur-mid.disabled, .btn-pur-mid:disabled {
    background-color: #7b8cde;
	border-color: #7b8cde;
	color: #fff
  }
  .btn-pur-mid:focus {
    box-shadow: 0 0 0 0.2rem rgba(149, 164, 236, 0.5);
  }
  .btn-pur-mid:hover, .btn-pur-mid:focus, .btn-pur-mid:not(:disabled):not(.disabled).active, .btn-pur-mid:not(:disabled):not(.disabled):active{
    background-color: #6372bb;
	border-color: #6372bb;
	color: #fff;
  }
  .btn-pur-dark, .btn-pur-dark.disabled, .btn-pur-dark:disabled{
    background-color: #3c4c9a;
	border-color: #3c4c9a;
	color: #fff
  }
  .btn-pur-dark:focus {
    box-shadow: 0 0 0 0.2rem rgba(92, 105, 168, 0.5);
  }
  .btn-pur-dark:hover, .btn-pur-dark:focus, .btn-pur-dark:not(:disabled):not(.disabled).active, .btn-pur-dark:not(:disabled):not(.disabled):active{
    background-color: #293366;
	border-color: #293366;
	color: #fff;
  }
  .btn-pur-outline, .btn-pur-outline.disabled, .btn-pur-outline:disabled {
    background-color: #fff;
	border-color: #7b8cde;
	color: #7b8cde
  }
  .btn-pur-outline:focus {
    box-shadow: 0 0 0 0.2rem rgba(149, 164, 236, 0.5);
  }
  .btn-pur-outline:hover, .btn-pur-outline:focus, .btn-pur-outline:not(:disabled):not(.disabled).active, .btn-pur-outline:not(:disabled):not(.disabled):active{
    background-color: #7b8cde;
	border-color: #7b8cde;
	color: #fff;
  }
  .p-card .card {
    box-shadow: 0 0 0.5rem #edeff2;
    border: none;
  }
  .card-body {
    padding: .8rem 1.25rem;
  }
  .card-title {
    font-size: 1.05rem;
	margin-bottom: .5rem;
	color: #7b8cde;
  }
  .card-text {
    font-size: 1.03rem;
	font-family: Roboto;
	color: #696f89;
	font-weight: lighter;
  }
  .more-hover {
    position: absolute;
	right: 0;
    bottom: 0;
    margin-right: 20px;
    margin-bottom: 8%;
    text-decoration: none;
    display: inline-block;
    text-transform: uppercase;
    opacity: 0;
    filter: alpha(opacity=0);
    -webkit-transition: all 0.4s ease;
    transition: all 0.4s ease;
    padding: 5px 7px;
	border-radius: 50%;
  }
  .p-card:hover img {
    opacity: .7
  }
  .p-card:hover .more-hover {
    opacity: 1;
    filter: alpha(opacity=100);
    -ms-transform: translatey(0);
    -webkit-transform: translatey(0);
    transform: translatey(0);
	-webkit-transition-delay: .2s;
    transition-delay: .2s;
	color: #5364b5;
    border-color: #5364b5;
  }
  .more-hover:hover {
    color: #fff!important;
    background-color: #3c4b92;
	border-color: #3c4b92;
  }
  @media (max-width: 1024px) {
  .more-hover {
	opacity: 1;
  }}
  .tab-content table td, .table th {
    border: 1px solid #dee2e6;
  }
  .list-group-item.active {
    background-color: #7b8cde;
  }
  ul.dropdown-menu.dropdown-menu-right.show {
    min-width: auto;
    background: #5364b5;
    padding: 0;
  }
  ul.dropdown-menu.dropdown-menu-right.show li:not(:last-child) {
    border-bottom: 1px solid #6e7dc3;
  }
  ul.dropdown-menu.dropdown-menu-right.show li a {
    color: #fff;
	font-size: .9rem;
	text-align: center;
  }
  .dropdown-item:focus, .dropdown-item:hover, .dropdown-item.active, .dropdown-item:active {
    background-color: #36427d;
  }
  .page-item.active .page-link {
    background-color: #c9cad9;
	border-color: #c9cad9;
  }
</style>
